import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Thumbs } from "swiper/modules";
import SwiperCore from "swiper";

import TestimonialIcon from "../assets/images/testimonial-icon.svg";
import testimonialUser1 from "../assets/images/testimonial-user-1.png";
import testimonialUser2 from "../assets/images/testimonial-user-2.png";
import testimonialUser3 from "../assets/images/testimonial-user-3.png";
import testimonialUser4 from "../assets/images/testimonial-user-4.png";
import testimonialUser5 from "../assets/images/testimonial-user-5.png";
import { useTestimonials } from "../hooks/useTestimonials";
import { ASSETS_URL } from "../api/constants";
// Initialize Swiper core
SwiperCore.use([Navigation, Thumbs]);

function Testimonials() {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const navigationPrevRef = React.useRef(null);
  const navigationNextRef = React.useRef(null);
    const { testimonials, loading, error } = useTestimonials();
  

  return (
    <section className="testimonials common-padding">
        <div className="common-header text-center">
          <h2>Testimonials from Satisfied Clients.</h2>
          <p>What people say!</p>
        </div>
      <div className="testimonials-slider">
      <Swiper
        modules={[Navigation, Thumbs]}
        slidesPerView={1}
        loop={true}
        navigation={{
          prevEl: navigationPrevRef.current,
          nextEl: navigationNextRef.current,
        }}
        onBeforeInit={(swiper) => {
          swiper.params.navigation.prevEl = navigationPrevRef.current;
          swiper.params.navigation.nextEl = navigationNextRef.current;
        }}
        thumbs={{
          swiper:
            thumbsSwiper && !thumbsSwiper.destroyed
              ? thumbsSwiper
              : null,
        }}
        className="main-swiper"
      >
        {testimonials?.map((item) => (
          <SwiperSlide key={item.id}>
            <div className="testimonials-box">
              <span>
                <img src={TestimonialIcon} alt="icon" />
              </span>

              <div className="testimonials-user-details">
                {/* DESCRIPTION (HTML) */}
                <div
                  div dangerouslySetInnerHTML={{ __html: item.description }}
                  
                />
              </div>
            </div>
          </SwiperSlide>
        ))}

        {/* NAVIGATION */}
        <div className="swiper-button-nav">
          <div
            ref={navigationPrevRef}
            className="swiper-button-prev"
          ></div>
          <div
            ref={navigationNextRef}
            className="swiper-button-next"
          ></div>
        </div>
      </Swiper>

      {/* THUMBNAIL SLIDER */}
      <Swiper
        modules={[Thumbs]}
        onSwiper={setThumbsSwiper}
        spaceBetween={10}
        slidesPerView={5}
        watchSlidesProgress={true}
        className="thumbs-swiper"
        breakpoints={{
          320: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
          480: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
          1200: {
            slidesPerView: 5,
            spaceBetween: 40,
          },
        }}
      >
        {testimonials?.map((item) => (
          <SwiperSlide key={item.id}>
            <img
              src={`${ASSETS_URL}${item.customer_image}`}
              alt={item.customer_name}
            />
            <h3>{item.customer_name}</h3>
            <span>{item.designation}</span>
          </SwiperSlide>
        ))}
      </Swiper>
      </div>
    </section>
  );
}

export default Testimonials;
